import { useState } from 'react';
import { Controller } from 'react-hook-form';

import { FormRow } from '@gravity-ui/components';

import { Button, Icon, Select, Sheet } from '@gravity-ui/uikit';
import { Xmark } from '@gravity-ui/icons';
import styles from '../styles.module.scss';

export const QuestionsSelect = ({ isMobile, formText, control, formValues, spokesmanOptions, errors }: any) => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<>
			{isMobile ? (
				<FormRow className={styles.info__row} label={formText.questionsBlank} required>
					<Controller
						control={control}
						name="spokesman"
						render={({ field: { onChange, onBlur, ref }, fieldState: { error } }) => {
							return (
								<Select
									placeholder={formText.chooseSpokesman}
									className={styles.info__row__select}
									size="xl"
									value={[formValues.spokesman]}
									onUpdate={(values) => onChange?.(values[0])}
									options={spokesmanOptions}
									validationState={error ? 'invalid' : undefined}
									errorPlacement="inside"
									errorMessage={error?.message}
									onBlur={onBlur}
									ref={ref}
									open={isOpen}
									onOpenChange={setIsOpen}
									renderPopup={({ renderFilter, renderList }) => (
										<Sheet
											visible={isOpen}
											onClose={() => setIsOpen(false)}
											title="Выберите представителя"
											className={styles.sheet}
										>
											<div className={styles.sheet__close}>
												<Button onClick={() => setIsOpen(false)} view="flat">
													<Icon data={Xmark} size={16} />
												</Button>
											</div>
											<div className={styles.sheet__content}>
												{renderFilter?.()}
												{renderList?.()}
											</div>
										</Sheet>
									)}
								/>
							);
						}}
					/>
				</FormRow>
			) : (
				<FormRow className={styles.info__row} label={formText.questionsBlank} required>
					<Controller
						control={control}
						name="spokesman"
						render={({ field: { onChange, onBlur, ref }, fieldState: { error } }) => (
							<Select
								placeholder={formText.chooseSpokesman}
								className={styles.info__row__select}
								size="xl"
								value={[formValues.spokesman]}
								onUpdate={(values) => onChange?.(values[0])}
								options={spokesmanOptions}
								validationState={errors.gender ? 'invalid' : undefined}
								errorPlacement="inside"
								errorMessage={error?.message}
								onBlur={onBlur}
								ref={ref}
							/>
						)}
					/>
				</FormRow>
			)}
		</>
	);
};
